<template>
  <div
    class="flex flex-col items-center pt-10 desktop:pt-[60px] px-3 pb-3 w-full"
  >
    <div class="w-full max-w-[440px] flex flex-col flex-grow">
      <div
        class="font-primary font-medium text-[26px] leading-[20px] tracking-[-0.38px] text-gray-800 mb-[56px]"
      >
        Checkout
      </div>

      <CheckoutSummary
        :selected-plan="selectedPlan"
        :selected-plan-item="selectedPlanItem"
        :selected-billing-cycle="selectedBillingCycle"
        :has-more-than-one-price="hasMoreThanOnePrice"
        :get-billing-cycle-price="getBillingCyclePrice"
        :format-upsell-text="formatUpsellText"
        @change="handleChangeClick"
        @upgrade="handleUpgradeClick"
      />

      <CheckoutPaymentForm
        :payment-method="paymentMethod"
        :card-classes="cardClasses"
        :accept-terms="acceptTerms"
        :loading="loading"
        :error-message="errorMessage"
        :selected-plan-item="selectedPlanItem"
        :selected-billing-cycle="selectedBillingCycle"
        :has-more-than-one-price="hasMoreThanOnePrice"
        :get-billing-cycle-price="getBillingCyclePrice"
        @update:accept-terms="acceptTerms = $event"
        @update-payment-method="handleUpdatePaymentMethod"
        @purchase="handlePurchase"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import CheckoutSummary from '@/features/billing/components/CheckoutSummary.vue'
import CheckoutPaymentForm from '@/features/billing/components/CheckoutPaymentForm.vue'
import { useCheckout } from '@/features/billing/composables/useCheckout'

const {
  acceptTerms,
  loading,
  errorMessage,
  selectedPlan,
  selectedPlanItem,
  selectedBillingCycle,
  getBillingCyclePrice,
  hasMoreThanOnePrice,
  cardClasses,
  paymentMethod,
  handleChangeClick,
  formatUpsellText,
  handleUpdatePaymentMethod,
  handleUpgradeClick,
  handlePurchase,
} = useCheckout()
</script>
